
const generalErroMessage = 'An error occurred. Let your accountant know this happened, and we\'ll fix it right away.';

export default {
    handleException: function (error, message = null) {
        console.log(error);
        alert(message ?? generalErroMessage);
        throw error;
    }
}